module.exports = __webpack_public_path__ + "static/img/doufu.b069588d.png";